import { IPaginationSettings } from 'wisestep-api';

export const defaultPaginationSettings: IPaginationSettings = {
  talentBenchPagination: '20',
  submittedCandidatesPagination: '20',
  jobCrmPagination: '20',
  candidatePagination: '20',
  jobsListPagination: '20',
};
